module.exports = "/packs/images/svg/facilities/golf~e5f070ada445f5f5d3307d802b072116.svg";